import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import type { FeatureTileName } from 'helpers/features';
import { convertJsonToFormData, mapFormData } from 'helpers/formData';

export interface PracticeSettingsFeatureTilesUpdatePatchOptions {
  image: File;
  name: FeatureTileName;
}

export function practiceSettingsFeatureTilesUpdateApi(path: string) {
  return {
    path,
    PATCH: (values: PracticeSettingsFeatureTilesUpdatePatchOptions) =>
      api.patch<JsonApiResponseSingle>(
        path,
        convertJsonToFormData({
          data: {
            attributes: mapFormData(values),
          },
        })
      ),
  };
}
